/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S4_I6Inputs */

const tr_kullanim_s4_i6 = /** @type {(inputs: Kullanim_S4_I6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tersine mühendislik, kaynak kodu çıkarma veya Platform altyapısını zorlama girişimleri yasaktır.`)
};

const en_kullanim_s4_i6 = /** @type {(inputs: Kullanim_S4_I6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reverse engineering, extracting source code or attempts to strain the Platform infrastructure are prohibited.`)
};

const de_kullanim_s4_i6 = /** @type {(inputs: Kullanim_S4_I6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reverse Engineering, das Extrahieren von Quellcode oder Versuche, die Infrastruktur der Plattform zu überlasten, sind untersagt.`)
};

const ru_kullanim_s4_i6 = /** @type {(inputs: Kullanim_S4_I6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обратная разработка, извлечение исходного кода или попытки перегрузить инфраструктуру Платформы запрещены.`)
};

/**
* | output |
* | --- |
* | "Reverse engineering, extracting source code or attempts to strain the Platform infrastructure are prohibited." |
*
* @param {Kullanim_S4_I6Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s4_i6 = /** @type {((inputs?: Kullanim_S4_I6Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S4_I6Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s4_i6(inputs)
	if (locale === "de") return de_kullanim_s4_i6(inputs)
	if (locale === "ru") return ru_kullanim_s4_i6(inputs)
	return tr_kullanim_s4_i6(inputs)
});